import { CheckCircle } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";
import { Button } from "components/UI";
import { useNavigate } from "react-router-dom";

export const Success = () => {
  const navigate = useNavigate();

  return (
    <Stack alignItems="center" justifyContent="center">
      <Stack
        spacing={4}
        alignItems="center"
        sx={{
          backgroundColor: "#F8F8F8",
          p: 4
        }}
      >
        <CheckCircle
          sx={{
            fontSize: 80,
            color: "success.main"
          }}
        />
        <Stack spacing={2} alignItems="center">
          <Typography variant="h5" fontWeight={600} color="success.main">
            Successfully Completed
          </Typography>
          <Typography
            variant="body1"
            textAlign="center"
            color="text.secondary"
            sx={{ maxWidth: 400 }}
          >
            You have successfully completed setting up finance! Your church is
            now ready to manage revenue, track expenses, and generate financial
            reports seamlessly. Let&apos;s continue to empower your ministry!
          </Typography>
        </Stack>
        <Button onClick={() => navigate("/finances/temp/overview")}>
          Continue to Finance
        </Button>
      </Stack>
    </Stack>
  );
};
